import { Quicklink } from "@obg/ngx.core.content";

import { SBPopularCategoriesResponse } from "../../../sdk/index";

export const SB_POPULAR_CATEGORY_RESPONSE: SBPopularCategoriesResponse = {
	items: [
		{
			key: "category.179",
			label: "Enhanced Accas",
			trackingLabel: "enhanced-accas",
			popularityOrder: 6,
		},
		{
			key: "category.119",
			label: "eSports",
			trackingLabel: "esports",
			popularityOrder: 109,
		},
		{
			key: "category.1",
			label: "Football",
			trackingLabel: "football",
			popularityOrder: 3014,
		},
		{
			key: "category.10",
			label: "American Football",
			trackingLabel: "american-football",
			popularityOrder: 148,
		},
		{
			key: "category.15",
			label: "Golf",
			trackingLabel: "golf",
			popularityOrder: 53,
		},
		{
			key: "category.2",
			label: "Ice hockey",
			trackingLabel: "ice-hockey",
			popularityOrder: 28,
		},
	],
};

export const ORDER_SB_POPULAR_CATEGORY_QUICK_LINK: Quicklink[] = [
	{
		documentKey: "category.football",
		label: { text: "Football" },
		link: { url: "/en/sportsbook/football" },
	},
	{
		documentKey: "category.american-football",
		label: { text: "American Football" },
		link: { url: "/en/sportsbook/american-football" },
	},
	{
		documentKey: "category.esports",
		label: { text: "Esports" },
		link: { url: "/en/sportsbook/esports" },
	},
	{
		documentKey: "category.golf",
		label: { text: "Golf" },
		link: { url: "/en/sportsbook/golf" },
	},
	{
		documentKey: "category.ice-hockey",
		label: { text: "Ice hockey" },
		link: { url: "/en/sportsbook/ice-hockey" },
	},
	{
		documentKey: "category.enhanced-accas",
		label: { text: "Enhanced Accas" },
		link: { url: "/en/sportsbook/enhanced-accas" },
	},
];

export const UNORDER_SB_POPULAR_CATEGORY_QUICK_LINK: Quicklink[] = [
	{
		documentKey: "category.esports",
		label: { text: "Esports" },
		link: { url: "/en/sportsbook/esports" },
	},
	{
		documentKey: "category.golf",
		label: { text: "Golf" },
		link: { url: "/en/sportsbook/golf" },
	},
	{
		documentKey: "category.enhanced-accas",
		label: { text: "Enhanced Accas" },
		link: { url: "/en/sportsbook/enhanced-accas" },
	},
	{
		documentKey: "category.american-football",
		label: { text: "American Football" },
		link: { url: "/en/sportsbook/american-football" },
	},
	{
		documentKey: "category.ice-hockey",
		label: { text: "Ice hockey" },
		link: { url: "/en/sportsbook/ice-hockey" },
	},
	{
		documentKey: "category.football",
		label: { text: "Football" },
		link: { url: "/en/sportsbook/football" },
	},
];
